import { useEffect, useRef } from 'react'
import { useRefreshListeners } from 'store'

const useSubscribeRefresh = (callback: () => void) => {
  const [, setListeners] = useRefreshListeners()
  const idRef = useRef(Math.random())

  useEffect(() => {
    setListeners((prev) => ({
      ...prev,
      [idRef.current]: callback
    }))

    return () => {
      setListeners((prev) => {
        const newListeners = {...prev}
        delete newListeners[idRef.current]
        return newListeners
      })
    }
  }, [])
}

export default useSubscribeRefresh